import { render, staticRenderFns } from "./DeleteAccountForm.vue?vue&type=template&id=5e09ae97&"
import script from "./DeleteAccountForm.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports